import request from '@/utils/request'

export function fetchSmsTemplates () {
  return request({
    url: 'sms/templates',
    method: 'get'
  })
}

export function sendSMS (params) {
  return request({
    url: 'sms/send',
    method: 'post',
    data: params
  })
}
